import { render, staticRenderFns } from "./ForwardTicket.vue?vue&type=template&id=0055f426&scoped=true&"
import script from "./ForwardTicket.vue?vue&type=script&lang=js&"
export * from "./ForwardTicket.vue?vue&type=script&lang=js&"
import style0 from "./ForwardTicket.vue?vue&type=style&index=0&id=0055f426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055f426",
  null
  
)

export default component.exports